<template>
  <div>
    <div @click="showDialog" @mouseenter="stop" @mouseleave="continuePlay" v-if="notice.length && isVertical" class="vertical-com">
      <swiper style="height: 84px" class="swiper-no-swiping" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in notice" :key="item.id">
          <div class="swiper-item">
            <p  class="title">{{item.name}}</p>
            <div class="content-wrap">
              <p class="content">{{item.content}}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="marquree-wrap" :class="{'white-color': isWhite}">
      <div v-if="notice.length>0 && !isVertical">
        <marquee class="" width="890px" onmouseover="this.stop();" onmouseout="this.start();"
                 scrollamount="8" scrolldelay="150"
                 style="line-height: 40px;cursor: pointer;color: #ffffff">
        <span class="content-item" @click="showDialog" v-for="(item,index) in notice"
              :title="item.name" :key="index">{{item.content}}</span>
        </marquee>
      </div>
    </div>
    <el-dialog title="最新消息"
               :modal-append-to-body="false"
               :show-close="false"
               :close-on-click-modal="false"
               width="600px"
               custom-class="marquee_dialog"
               :visible.sync="dialogTableVisible">
      <div class="wordSwiper">
        <swiper :options="swiperOptionV">
          <swiper-slide class="text">
            <div class="text-content" :class="{noTop: index === 0}" v-for="(item,index) in notice" :key="index">
              <p class="title">
                {{item.name}}
              </p>
              <p class="content">{{item.content}}</p>
            </div>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogTableVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
import {mapState} from 'vuex';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
    name: 'marqueeN',
    props: {
      isVertical: {
        default: false,
        type: Boolean
      },
      isWhite:{
        default: false,
        type: Boolean
      }
    },
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        notice: [],
        dialogTableVisible: false,
        // 轮播
        swiperOption: {
          direction: 'vertical',
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
        },
        swiperOptionV: {
          direction: 'vertical',
          slidesPerView: 'auto',
          freeMode: true,
          scrollbar: {
            el: '.swiper-scrollbar'
          },
          mousewheel: true
        },
      }
    },
    computed: {
      ...mapState({
        frontType: state => state.frontType
      }),
      swiper() {
        if(this.notice.length) {
          return this.$refs.mySwiper.swiper
        }
      }
    },
    methods: {
      continuePlay() {
        this.swiper.autoplay.start()
      },
      stop() {
        this.swiper.autoplay.stop()
      },
      showDialog() {
        this.dialogTableVisible =true
      },
      pushInfoList() {
        let params = {
          frontType: 2,
        };
        this.$api.post(this.$urls.HOMEBEFORE.PUSHINFOLIST,params,resp=>{
          if(resp.data.code===200){
            this.notice =resp.data.data.list;
          }else {
            this.notice = []
          }
        },err=>{})
      },
    },
    mounted() {
      this.pushInfoList()
    },
    activated() {
      this.pushInfoList()
    },
    deactivated() {
      this.notice = []
    }
  };
</script>

<style scoped lang="scss">
  @import '../../style/variable.scss';
  .vertical-com{overflow: hidden;height: 84px;color: #fff;
    .swiper-item{
      &:hover{cursor: pointer;
        .content{text-decoration: underline}
      }
      .title{padding: 3px 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
      .content-wrap{height: 60px;line-height: 20px;overflow: hidden;
        &:before {float: left;width: 5px;content: '';height: 40px;}
        .content{float: right;margin-left: -5px;width: 100%;word-break: break-all;
          &:after{float: right;content: "...";height: 20px;line-height: 20px; /* 为三个省略号的宽度 */width: 3em; /* 使盒子不占位置 */margin-left: -3em; /* 移动省略号位置 */position: relative;left: 100%;top: -20px;padding-right: 5px;}
        }
      }
    }

  }
  .marquree-wrap {padding: 0px 0px 0px 110px;font-size: 14px;background-image: url("../../assets/images/common/marquee/news.png");background-repeat: no-repeat;background-position: 10px center;
    .content-item{color: #ffffff;margin-left: 80px;&:hover{text-decoration: underline}}
  }
  .white-color{background-image: url("../../assets/images/common/marquee/news-white.png");background-position: left center;}
  .wordSwiper{
    .swiper-container{height: 300px;width: 100%;
      .swiper-slide.text {height: auto;font-size: 16px!important;text-align: left!important;padding: 0 10px;
        > .text-content {height: auto;margin-top: 15px;border-bottom: 1px #999999 dashed;padding-bottom: 5px;position: relative;
          &:before{content: "";display:block;position: absolute;left: -10px;top: 10px;width: 5px;height: 5px;border-radius: 100%;background: #666666;}
          > p {line-height: 1.6;}
          .title {line-height: 1.6;}
          .content {line-height: 1.6;}
        }
        .noTop{margin-top: 0}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/base/marqueeN.vue